import { useState, useCallback } from "react";
export const getLocalStorage = () => {
    return new Proxy(localStorage, {
        set: (_, key, value) => {
            if (typeof key !== "string") {
                throw new Error("The key should be a string");
            }
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        },
        get: (_, key) => {
            if (typeof key !== "string") {
                throw new Error("The key should be a string");
            }
            const value = localStorage.getItem(key);
            if (value === null) {
                return null;
            }
            try {
                return JSON.parse(value);
            }
            catch (err) {
                return value;
            }
        },
    });
};
export function useLocalStorage(key) {
    const storage = getLocalStorage();
    const [storedValue, setStoredValue] = useState(() => storage[key]);
    const setValue = useCallback((value) => {
        try {
            setStoredValue(value);
            storage[key] = value;
        }
        catch (error) {
            console.log(error);
        }
    }, [key, storage]);
    return [storedValue, setValue];
}
//# sourceMappingURL=useLocalStorage.js.map